import type { ContentRow } from "../api";
import { BarList } from "../charts/bar-list";
import { count, duration } from "../format";
import type { ItemRef } from "../item-names";

/** The most played items as ranked bars, each linking to its page (Home and the Overview). */
export function TopContent({ rows, nameOf, limit = 5 }: { rows: readonly ContentRow[]; nameOf: (id: string) => ItemRef; limit?: number }) {
  const top = [...rows].sort((a, b) => b.plays - a.plays).slice(0, limit);
  return (
    <BarList label="Most played"
      bars={top.map((r) => {
        const item = nameOf(r.itemId);
        return { key: r.itemId, label: item.label, href: item.href, value: r.plays, text: `${count(r.plays)} ${r.plays === 1 ? "play" : "plays"}`, detail: `${duration(r.watchSeconds)} watched · ${count(r.viewers)} ${r.viewers === 1 ? "viewer" : "viewers"}` };
      })} />
  );
}
